
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52","fill":"currentColor"}}),_c('path',{attrs:{"d":"M35.129 69.478v-9.051l4.2 4.176 1-1.006-5.409-5.377a.711.711 0 00-1 0l-5.409 5.38 1 1.006 4.2-4.176v9.051a6.109 6.109 0 006.118 6.086h2.7v-1.421h-2.7a4.689 4.689 0 01-4.7-4.668zM69.08 58.22l-5.409 5.38 1 1.006 4.2-4.176v9.051a4.689 4.689 0 01-4.7 4.668h-2.705v1.418h2.705a6.109 6.109 0 006.118-6.086v-9.054l4.2 4.176 1-1.006-5.409-5.377a.711.711 0 00-1 0zM35.772 45.986a7.371 7.371 0 007.471-7.43v-2.689a7.471 7.471 0 00-14.941 0v2.689a7.37 7.37 0 007.47 7.43zM29.72 35.867a6.053 6.053 0 0112.105 0v2.689a6.053 6.053 0 01-12.105 0zm38.508 10.119a7.37 7.37 0 007.47-7.43v-2.689a7.471 7.471 0 00-14.941 0v2.689a7.371 7.371 0 007.471 7.43zm-6.053-10.119a6.053 6.053 0 0112.105 0v2.689a6.053 6.053 0 01-12.105 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M68.228 48.6C64.428 48.6 54 50.045 54 54.688v6.723h1.418v-6.723c0-2.806 7.712-4.668 12.814-4.668s12.814 1.862 12.814 4.668v6.723h1.414v-6.723c0-4.643-10.433-6.088-14.232-6.088zm-32.456 0c-3.8 0-14.232 1.442-14.232 6.085v6.723h1.418v-6.72c0-2.806 7.713-4.668 12.814-4.668s12.814 1.862 12.814 4.668v6.723H50v-6.723c0-4.643-10.428-6.088-14.228-6.088zm14.875 25.546h2.705v1.418h-2.705zm-5.409 0h2.705v1.418h-2.705zm10.819 0h2.705v1.418h-2.705z","fill":"currentColor"}})])
          )
        }
      }
    